document.addEventListener('DOMContentLoaded', function () {
    var accordionHeaders = document.querySelectorAll('.accordion-header');

    accordionHeaders.forEach(function (header, index) {
        header.addEventListener('click', function () {
            toggleAccordion(index + 1);
        });
    });

    function toggleAccordion(sectionNumber) {
        var content = document.getElementById("accordion-content-" + sectionNumber);
        var currentHeader = document.getElementById("accordion-header-" + sectionNumber);
        var plusIcon = document.getElementById('plus-solid-' + sectionNumber);
        var minusIcon = document.getElementById('minus-solid-' + sectionNumber);

        if (content && plusIcon && minusIcon) {
            if (content.style.display === "block") {
                content.style.display = "none";
                plusIcon.classList.remove('expanded');
                minusIcon.classList.remove('expanded');
                currentHeader.classList.remove('open'); // Remove the open class when closing
            } else {
                // Close all other accordion contents
                document.querySelectorAll('.accordion-content').forEach(function (item) {
                    item.style.display = "none";
                });
                
                // Remove open class from all other headers
                document.querySelectorAll('.accordion-header').forEach(function (header) {
                    header.classList.remove('open');
                });

                // Open the current one
                content.style.display = "block";
                content.style.minHeight = "100px";
                plusIcon.classList.add('expanded');
                minusIcon.classList.add('expanded');
                currentHeader.classList.add('open'); // Add the open class when opening
            }
        }
    }
});
